export default "__VITE_ASSET__d758981e__"